import type { Asset } from '@schibsted-svp/svp-api-types';

import type { PlayerContext } from '../../../../types/global';
import {
  getAssetAccess,
  isSportAccessLevel,
} from '../../../../utils/player/asset';
import { AssetTitle } from '../../components/AssetTitle/AssetTitle';
import { useProvider } from '../../hooks/useProvider';

export const AssetTitleContainer = ({
  asset,
  context,
  titleOverride,
}: {
  asset?: Asset;
  context: PlayerContext;
  titleOverride?: string;
}) => {
  const { configProvider } = useProvider();

  if (!asset || context !== 'embed') {
    return null;
  }

  const sportAccessLevel = isSportAccessLevel(
    configProvider,
    getAssetAccess(asset)
  );

  return (
    <div className="vgp-asset-title-container">
      <AssetTitle
        asset={asset}
        shouldRenderAssetLabel={!sportAccessLevel}
        titleOverride={titleOverride}
      />
    </div>
  );
};
